module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_factory-47bd8e3339f38f0c202e998a19152dd5.svg";